/*
* Report page
*/

import * as KendoCharts from '@progress/kendo-react-charts';
import * as React from 'react';
import * as _ from 'lodash';
import { Table } from 'react-bootstrap';

import * as ReportCharts from '../../charts';
import { Formatters } from '../../../common/formatters';
import * as ReportComponents from '../report-components';

export const Render = ({ registerFunc, refFunc, scrollToFunc, appText, pageTitle = '', className = '', pageConfiguration, pageCount, reportData, ...rest }) => {
    const sectionName = ReportComponents.ReportSectionNames.reserveContributionsGraph;
    const ReportPageWithRegister = ReportComponents.withPageRegistration(ReportComponents.ReportPageHeaderFooter, sectionName, registerFunc, refFunc, scrollToFunc);

    const { formData, association, calculations, isHypothetical, inventory, currentOrder, currentOrderChart, percentFunded, yearlySummaryData } = reportData;

    // COMMON
    const showMinimum = _.get(currentOrderChart, 'showMinimum', true);
    const showCurrent = _.get(currentOrderChart, 'showCurrent', true);

    // PERCENT FUNDED CHART
    const chartDataAll = ReportCharts.getReserveContributionsChartData((e) => appText(e), calculations, formData.beginYear, formData.calculateYears, isHypothetical);
    const chartData = _.filter(chartDataAll, (o) => {
        switch (_.get(o, 'name', '')) {
            case 'Current MRC':
                return showCurrent;

            case 'Minimum MRC':
                return showMinimum;

            default:
                return true;
        }
    });

    const chartCategories = ReportCharts.getChartCategoriesYearDates(formData.beginYear, formData.calculateYears);
    const chartColors = ReportCharts.getBrandedChartColors();
    const chartAxisTitleFontConfig = 'bold 20px Arial, sans-serif';
    const chartAxisLabelFontConfig = '12px Arial, sans-serif';
    const chartLegendLabelColorConfig = 'color: #000000';

    const chartSeriesColors = {
        'Recommended MRC': chartColors[0],
        'Current MRC': chartColors[1],
        'Minimum MRC': chartColors[2],
    };

    const rcChart = (
        <KendoCharts.Chart renderAs={pageConfiguration.kendoCharts.renderAs}>
            <KendoCharts.ChartTitle text="Monthly Reserve Contributions" font={chartAxisTitleFontConfig} />
            <KendoCharts.ChartArea height={800} />
            <KendoCharts.ChartLegend
                labels={{ font: chartAxisLabelFontConfig, padding: 10, color: chartLegendLabelColorConfig }}
                position="bottom"
                orientation="horizontal"
            />
            <KendoCharts.ChartSeries>
                {
                    chartData.map((item, idx) => (
                        <KendoCharts.ChartSeriesItem
                            color={chartSeriesColors[_.get(item, 'name')]}
                            key={`reserve-contributions-chart-${idx}`}
                            type="column"
                            data={_.get(item, 'data')}
                            name={_.get(item, 'name')}
                            overlay={{ gradient: 'glass' }}
                        />
                    ))}
            </KendoCharts.ChartSeries>

            <KendoCharts.ChartValueAxis>
                <KendoCharts.ChartValueAxisItem
                    line={{ color: '#000000', width: 2 }}
                    majorGridLines={{ color: '#c5c5c5', width: 2 }}
                    title={{ text: 'Amount', font: chartAxisTitleFontConfig, color: chartLegendLabelColorConfig }}
                    labels={{ format: 'c0', font: chartAxisLabelFontConfig, color: chartLegendLabelColorConfig }}
                />
            </KendoCharts.ChartValueAxis>

            <KendoCharts.ChartCategoryAxis>
                <KendoCharts.ChartCategoryAxisItem
                    categories={chartCategories}
                    baseUnit="years"
                    baseUnitStep={1}
                    maxDivisions={16}
                    type="date"
                    majorGridLines={{ width: 0 }}
                    line={{ color: '#000000', width: 2 }}
                >
                    <KendoCharts.ChartCategoryAxisTitle text="Year" font={chartAxisTitleFontConfig} color={chartLegendLabelColorConfig} />
                    <KendoCharts.ChartCategoryAxisLabels font={chartAxisLabelFontConfig} color={chartLegendLabelColorConfig} />
                </KendoCharts.ChartCategoryAxisItem>
            </KendoCharts.ChartCategoryAxis>
        </KendoCharts.Chart>
    );

    const page = (
        <ReportPageWithRegister
            title={pageTitle}
            className={className}
            totalPageCount={pageCount}
            showFooter={true}
            footerData={reportData}
        >
            <div className="pdf-page-chart">
                {rcChart}
            </div>
        </ReportPageWithRegister>
    );

    return (
        <div>
            {page}
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/report/pdf/pages/report-page-reserve-contributions-graph-kendo.tsx